import SpecialBogo from 'src/dispensary/specials/offer';
import { CoreMenuLayout } from 'components/layouts/core-menu-layout';

SpecialBogo.layout = CoreMenuLayout;
export default SpecialBogo;
